/* © CNES */
import { filterSections } from '../../../../../assets/config/filters/Referenciel';
import { SelectButtonItem } from '../../../../../models/SelectButtonItem';
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { FilterSelectButtons } from '../FilterSelectButtons/FilterSelectButtons';

/**
 * Product Type Condition Props.
 */
export interface AqcuisitionTypeConditionProps {
  handleChange: (e: any, key: string) => void;
  acquisitionTypeOptions: SelectButtonItem[] | null;
}

/**
 * Acquisition Type Condition will display the filter depending on Acquisition Type selection.
 * @param handleChange Function to handle when a mode button is clicked.
 * @returns AcquisitionTypeCondition Element.
 */
export const AcquisitionTypeCondition = ({
  handleChange,
  acquisitionTypeOptions,
}: AqcuisitionTypeConditionProps) => {
  /**
   * onChange Mode
   * @param value mode(s)
   */
  const onChangeAcquisitionType = (value: string | number[]) => {
    handleChange(value, filterSections.acquisitionType.param);
  };

  return (
    <div className="visibilityFilter">
      <CustomAccordion
        title={filterSections.acquisitionType.title}
        children={
          <FilterSelectButtons
            name={filterSections.acquisitionType.param}
            options={acquisitionTypeOptions ?? []}
            handleChange={onChangeAcquisitionType}
          />
        }
      />
    </div>
  );
};
